/*
 * DateTimePicker Messages
 *
 * This contains all the text for the DateTimePicker component.
 */

import { defineMessages } from "react-intl";

export const scope = "app.components.DateTimePicker";

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: "This is the DateTimePicker component!",
  },
  datePlaceholder: {
    id: `${scope}.datePlaceholder`,
    defaultMessage: "Select preferred date and time",
  },
});
